import styled from 'styled-components';
import PasswordReset from './PasswordReset';
import { colorSchema } from 'utils/style';

export default styled(PasswordReset)`
  .password-reset {
    display: flex;
    flex-direction: column;

    &__input {
      height: 100%;
      margin-bottom: 1.6rem;
      min-width: 284px;
      width: 100%;

      input {
        height: 48px;
      }

      &--error {
        margin-bottom: 0;
      }
    }

    &__submit {
      border-radius: 4px;
      margin-top: 0.8rem;
    }

    &__error {
      background-color: ${colorSchema('error100')};
      border-width: 0 1px 1px 1px;
      border-style: solid;
      border-color: ${colorSchema('error500')};
      border-radius: 0 0 4px 4px;
      color: ${colorSchema('error900')};
      display: flex;
      font-size: 1.4rem;
      font-weight: 500;
      margin-bottom: 1.6rem;
      max-width: 284px;
      padding: 0.8rem;
      width: 100%;
    }
  }
`;
